module.exports = __webpack_public_path__ + "img/gender.4c0741de.svg";